import { Redirect, Route } from 'react-router-dom';

import MarketingLayout from 'view/marketing/layout/MarketingLayout';
import { marketingPages } from 'view/marketing/pages';
import { useDocumentMeta } from 'view/marketing/lib/useDocumentMeta';

function MarketingPage({ component: Component, title, description }) {
	useDocumentMeta({ title, description });
	return (
		<MarketingLayout>
			<Component />
		</MarketingLayout>
	);
}

const HOME = marketingPages.find((page) => page.path === '/');
const INNER_PAGES = marketingPages.filter((page) => page.path !== '/');

// Public marketing pages (VWA-2898): /about, /features, /pricing, ...
export function MarketingRoutes() {
	return [
		...INNER_PAGES.map((page) => (
			<Route key={page.path} exact path={page.path}>
				<MarketingPage {...page} />
			</Route>
		)),
		<Route key="/agencies" exact path="/agencies">
			<Redirect to="/property-data" />
		</Route>,
	];
}

// The home page also stays the fallback for unmatched URLs, as the old landing page was.
// Must be the last route in the Switch.
export function MarketingHomeRoute() {
	return (
		<Route key="/" path="/">
			<MarketingPage {...HOME} />
		</Route>
	);
}
